import {
  agDepartmentsCol,
  agDetailCol,
  agEndDateCol,
  agPriceCol,
  agSelectCol,
  agStartDateCol,
  agStatusCol
} from '@/ag-grid/ag-columns'
import { formatPrice } from '@lib/formatting.utils'

export default {
  computed: {
    options() {
      return {
        columnDefs: [
          agSelectCol({ vuexModule: 'recommendations' }),

          agStatusCol(),

          {
            headerName: 'SUBSCRIPTIONS',
            field: 'name',
            type: ['textFilterColumn'],
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/subscriptions/${params.data.subscription.id}`
              }
            }
          },

          {
            headerName: 'PUBLISHER',
            field: 'publisher.name',
            type: ['textFilterColumn']
          },

          {
            headerName: 'VENDOR',
            field: 'vendor.name',
            tooltipValueGetter: params => params.value || 'N/A',
            cellRenderer: params => params.value || 'N/A',
            type: ['textFilterColumn']
          },

          agDepartmentsCol('recommendations', {
            headerName: this.departmentLabel.plural
          }),

          agStartDateCol({ hide: true }),

          agEndDateCol({ hide: true }),

          agDetailCol(),

          agPriceCol('FORECASTED PRICE', 'forecasted_price'),

          agPriceCol('USAGE', 'usage_from_two_periods_ago', { cellRenderer: params => params.value ?? 'N/A' }),

          agPriceCol('FORECASTED CPU', 'forecasted_cost_per_use_from_two_periods_ago_original_currency', {
            headerClass: ['multiple-lines', 'ag-right-aligned-cell', 'ag-right-aligned-header'],
            cellRenderer: params => params.value || 'N/A'
          }),

          agPriceCol('PRICE', 'price'),

          {
            headerName: 'POSITIVE FEEDBACK',
            colId: 'positive_stakeholders_count/stakeholders_count',
            filter: false,
            sortable: false,
            valueGetter: params => {
              if (!params?.data) return // Ag grid runs valueGetter even when the table has no rows
              if (!params.data.stakeholders_count) return 'N/A'
              return `${params.data.positive_stakeholders_count}/${params.data.stakeholders_count}`
            },
            type: ['centerAligned'],
            headerClass: ['multiple-lines', 'text-center'],
            minWidth: 70,
            width: 70
          },

          agPriceCol(`${this.departmentLabel.singular} share %`, 'department_share_percentage', {
            cellRenderer: params => {
              if (params.value === null) return 'N/A'
              return `${formatPrice(params.value)} %`
            },
            hide: true
          }),

          agPriceCol(`${this.departmentLabel.singular} cost (original currency)`, 'department_cost', { hide: true }),

          {
            headerName: 'RECOMMENDATIONS',
            minWidth: 416,
            width: 416,
            maxWidth: 416,
            pinned: 'right',
            sortable: false,
            filter: 'CustomFilter',
            type: ['centerAligned'],
            floatingFilterComponentFramework: 'StatusesFilter',
            filterParams: {
              vuexModule: 'recommendations',
              vuexState: 'statuses'
            },
            field: 'recommendation_status.name',
            cellRendererFramework: 'StatusesEditor',
            cellRendererParams: params => ({
              vuexModule: 'recommendations',
              vuexState: 'statuses',
              disable: params.data.status.name !== 'pending'
            })
          }
        ],

        defaultColDef: {
          floatingFilter: true
        },

        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        cacheBlockSize: 40
      }
    }
  }
}
